function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M15 13v4.75A2.25 2.25 0 0112.75 20h-7.5a2.25 2.25 0 01-1.59-.658 2.25 2.25 0 01-.66-1.59V13.25a2.25 2.25 0 01.658-1.59 2.25 2.25 0 011.59-.66H9m-3 6h2"
}), /*#__PURE__*/React.createElement("rect", {
  width: "12",
  height: "9",
  x: "9",
  y: "4",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  rx: "2.25"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "15",
  cy: "8.5",
  r: "1.5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M20 17v4m2-2l-2-2-2 2M4 7V3M2 5l2 2 2-2"
}));